import { render, staticRenderFns } from "./PagePortage.vue?vue&type=template&id=4c30ad13&"
import script from "./PagePortage.vue?vue&type=script&lang=js&"
export * from "./PagePortage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c30ad13')) {
      api.createRecord('4c30ad13', component.options)
    } else {
      api.reload('4c30ad13', component.options)
    }
    module.hot.accept("./PagePortage.vue?vue&type=template&id=4c30ad13&", function () {
      api.rerender('4c30ad13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/PagePortage.vue"
export default component.exports